import { withClientState } from 'apollo-link-state';
import cache from './apolloCache';
import {
  LOCALE,
  AUTH_TOKEN,
  COUNTRY_CODE,
  GUEST_TOKEN,
} from 'config/constants';

// console.log('test', window.location.pathname);
const path = window.location.pathname;
let pathLang = path.split('/')[1];
pathLang = ['en', 'ar'].includes(pathLang) ? pathLang : undefined;
if (pathLang) {
  localStorage.setItem(LOCALE, pathLang);
}

const defaultLocale = pathLang || localStorage.getItem(LOCALE) || 'en';
const defaultCountryCode = localStorage.getItem(COUNTRY_CODE) || 'EG';
const isToken =
  !!localStorage.getItem(AUTH_TOKEN) || !!localStorage.getItem(GUEST_TOKEN);
const isLoggedIn = !!localStorage.getItem(AUTH_TOKEN);

const defaultState = {
  languageState: {
    __typename: 'LanguageState',
    locale: defaultLocale,
  },
  isToken,
  isLoggedIn,
  firstSignup: {
    __typename: 'firstSignup',
    isNewMember: false,
  },
  geo: {
    __typename: 'Geo',
    countryCode: defaultCountryCode,
  },
};

const stateLink = withClientState({
  cache,
  defaults: defaultState,
  resolvers: {
    Mutation: {
      updateLocale: (_, { locale }, { cache: currentCache }) => {
        const data = {
          languageState: {
            __typename: 'LanguageState',
            locale,
          },
        };
        currentCache.writeData({ data });
        return null;
      },
      updateGeo: (_, params, { cache: currentCache }) => {
        const data = {
          geo: {
            __typename: 'Geo',
            ...params,
          },
        };
        currentCache.writeData({ data });
        return null;
      },
      updateFirstSignup: (_, params, { cache: currentCache }) => {
        const data = {
          firstSignup: {
            __typename: 'firstSignup',
            ...params,
          },
        };
        currentCache.writeData({ data });
        return null;
      },
    },
  },
});

export default stateLink;



// WEBPACK FOOTER //
// ./app/stateLink.js